import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCopy, FiFacebook, FiInstagram, FiLinkedin } = FiIcons;

function SocialShare({ score, total, text }) {
  const [copied, setCopied] = useState(false);
  const pageUrl = window.location.href;
  const shareText = `${text} Ik had ${score}/${total} juist.`;

  const copyForInstagram = async () => {
    try {
      await navigator.clipboard.writeText(`${shareText} ${pageUrl}`);
      setCopied(true);
      window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
    } catch {
      setCopied(false);
    }
  };

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`;

  return (
    <section className="social-share" aria-label="Deel je score">
      <p>Deel jouw score</p>
      <div className="social-share__actions">
        <a
          href={facebookUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Deel je score op Facebook"
        >
          <SafeIcon icon={FiFacebook} aria-hidden="true" />
          <span>Facebook</span>
        </a>
        <button
          type="button"
          onClick={copyForInstagram}
          aria-label="Kopieer je score en open Instagram"
        >
          <SafeIcon icon={copied ? FiCopy : FiInstagram} aria-hidden="true" />
          <span>{copied ? 'Gekopieerd' : 'Instagram'}</span>
        </button>
        <a
          href={linkedinUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Deel je score op LinkedIn"
        >
          <SafeIcon icon={FiLinkedin} aria-hidden="true" />
          <span>LinkedIn</span>
        </a>
      </div>
    </section>
  );
}

export default SocialShare;